export default {
    removeItem:function (arr,item){
        var index = arr.indexOf(item)
        if (index !== -1) {
            arr.splice(index, 1)
        }
    },
    /**
     * 子arr根据属性关系放到父arr的某个属性里
     * @param parentArr 父arr
     * @param childrenArr 子arr
     * @param idProperty 根据哪个属性确定关系
     * @param children 子arr放到父arr的哪个属性里
     */
    arrToArrChildren(parentArr, childrenArr, idProperty, children){
        let tableMap = new Map;
        let numberArr = []
        parentArr.forEach((value, index) => {
            value[children]=[]
            tableMap.set(value[idProperty],value)
            numberArr.push(value[idProperty])
        })
        childrenArr.forEach((value, index) => {
            if(tableMap.get(value[idProperty])){
                tableMap.get(value[idProperty])[children].push(value)
            }
        })
        parentArr=[]
        numberArr.forEach((value, index) => {
            parentArr.push(tableMap.get(value))
        })
        return parentArr
    }
}